<template>
  <contracts-shell v-if="useNewView" @legacy="openLegacy" />
  <contracts-legacy v-else @new-view="openNewView" />
</template>

<script>
import ContractsLegacy from "./ContractsLegacy.vue";
import ContractsShell from "@/components/contracts-shell/ContractsShell.vue";
import { CONTRACTS_QUERY, LEGACY_UI_VALUE } from "@/components/contracts-shell/contractsQuery";

/**
 * Ugovori (/ugovori) imaju novi izgled kao izvještaji, finansije i firme za dostavu; ?ui=stari vraća staru stranicu (ContractsLegacy).
 */
export default {
  name: "ContractsOverviewPage",
  components: { ContractsLegacy, ContractsShell },
  computed: {
    useNewView() {
      return this.$route.query[CONTRACTS_QUERY.legacy] !== LEGACY_UI_VALUE;
    },
  },
  methods: {
    openLegacy() {
      this.$router.replace({ query: { ...this.$route.query, [CONTRACTS_QUERY.legacy]: LEGACY_UI_VALUE } }).catch(() => {});
    },
    openNewView() {
      const query = { ...this.$route.query };
      delete query[CONTRACTS_QUERY.legacy];
      this.$router.replace({ query }).catch(() => {});
    },
  },
};
</script>
